import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

import {MAP_TYPE_BY_INDEX} from './map_type';
import {
  averagePriceDataSelector,
  getDeliveryType,
  eventStatsSelector,
  eventSortBySelector,
  listingAvailableQtySelector,
  filterFooterDataSelector,
  isLoading,
  deviceSelector,
  getLocale,
  getPriceIncludeFeesPreselected,
  listingDataSelector,
  getShowPricingFilter,
  availableTicketTypesSelector,
  isInstantTicketAvailableSelector,
  getShowInstantDeliveryFilter,
} from './selectors';

const NAMESPACE = 'royal_FilterInfo';
const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const localState = this.getLocalState(state) || {};
    const {minPrice, maxPrice, ...restOfListingDataParams} = listingDataSelector(state);
    const {deliveryTypes} = getDeliveryType(localState);
    const availableTicketTypes = availableTicketTypesSelector(localState);

    return {
      deliveryTypes,
      availableTicketTypes,
      isInstantAvailable: isInstantTicketAvailableSelector(localState),
      ...eventStatsSelector(state),
      minPrice,
      maxPrice,
      ...restOfListingDataParams,
      ...eventSortBySelector(state),
      ...listingAvailableQtySelector(state),
      ...averagePriceDataSelector(state),
      ...filterFooterDataSelector(state),
      device: deviceSelector(state),
      isLoading: isLoading(state),
      locale: getLocale(state),
      isPriceIncludeFeesPreselected: getPriceIncludeFeesPreselected(state),
      showPricingFilter: getShowPricingFilter(minPrice, maxPrice)(state),
      showInstantDeliveryFilter: getShowInstantDeliveryFilter(state),
    };
  },

  actionCreators: {
    fetchFullfilmentWindow,
    updateMaptype,
  },
  reducers: [
    'ROYALFILTER:FULLFILLMENT_LOADING',
    'ROYALFILTER:FULLFILLMENT_LOADED',
    {
      action: 'MAP:UPDATE_MAP_TYPE',
      handler: (state, data) => {
        const newEventState = {...state.event};
        newEventState.venueConfig.map.mapType = MAP_TYPE_BY_INDEX.indexOf(data.value);

        return {
          event: newEventState,
        };
      },
    },
  ],
});

function updateMaptype(mapType) {
  return (dispatch) => {
    dispatch({type: 'MAP:UPDATE_MAP_TYPE', value: mapType});
  };
}

/**
 * Fetches the fulfillment window for a given event.
 *
 * @param {string} eventId - The ID of the event.
 * @returns {Promise<Object>} - A promise that resolves to the response body.
 */
function fetchFullfilmentWindow(eventId) {
  return async (dispatch, getState) => {
    dispatch({type: 'ROYALFILTER:FULLFILLMENT_LOADING'});
    const body = await get({
      host: process.env.REACT_APP_API_HOST,
      path: `/fulfillment/window/v1/event/${eventId}`,
      headers: _getFetchRequestHeaders(getState().lang),
      json: true,
    });
    const {fulfillmentWindows = []} = body;
    dispatch({type: 'ROYALFILTER:FULLFILLMENT_LOADED', fulfillmentWindows});

    return body;
  };
}

function _getFetchRequestHeaders(language) {
  const ret = {
    Authorization: process.env.REACT_APP_API_SECRET,
  };
  if (language) {
    ret['Accept-Language'] = language;
  }

  return ret;
}

export default controller;
